import { IAiAssistStore } from './types';

const initStore: IAiAssistStore = {
  aiPrompt: null,
  noteAssist: null,
};

export default initStore;
